import axiosInstance from './axiosInstance';

const OPERADORES_API_URL = '/operadores';

const operadoresService = {
  async get(idempresa, posto, tpv) {
    try {
      const response = await axiosInstance.get(`${OPERADORES_API_URL}/get.php?idempresa=${idempresa}&posto=${posto}&tpv=${tpv}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter operadores:', error);
      return [];
    }
  }
};

export default operadoresService;
